/* Gaiety Gems: reveal, parallax, hero video and stone scroller */
(function () {
  document.documentElement.classList.add('gg-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  function reveal(root) {
    var els = (root || document).querySelectorAll('.gg-reveal:not(.is-visible)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  var parallaxItems = [];
  var ticking = false;
  function updateParallax() {
    parallaxItems.forEach(function (el) {
      var box = el.parentElement.getBoundingClientRect();
      if (box.bottom < 0 || box.top > window.innerHeight) return;
      el.style.transform = 'translate3d(0,' + (box.top * -0.16).toFixed(1) + 'px,0)';
    });
    ticking = false;
  }
  function parallax() {
    if (reduce) return;
    parallaxItems = Array.prototype.slice.call(document.querySelectorAll('[data-gg-parallax]'));
    updateParallax();
  }
  window.addEventListener('scroll', function () {
    if (!ticking && parallaxItems.length) { window.requestAnimationFrame(updateParallax); ticking = true; }
  }, { passive: true });

  function heroVideo(root) {
    (root || document).querySelectorAll('.gg-hero video').forEach(function (v) {
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.removeAttribute('controls');
      if (reduce) { v.removeAttribute('autoplay'); v.pause(); return; }
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  function scrollers(root) {
    (root || document).querySelectorAll('[data-gg-scroller]').forEach(function (wrap) {
      if (wrap.dataset.ggReady) return;
      wrap.dataset.ggReady = '1';
      var track = wrap.querySelector('.gg-stones__track');
      wrap.querySelectorAll('[data-gg-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-gg-dir') === 'next' ? 1 : -1;
          track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    });
  }

  function init(root) { reveal(root); parallax(); heroVideo(root); scrollers(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

if (!customElements.get('gg-mobile-purchase')) {
  customElements.define('gg-mobile-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      document.querySelectorAll('gg-mobile-purchase').forEach((other) => {
        if (other !== this && other.dataset.submitId === this.dataset.submitId) other.remove();
      });
      this.button = this.querySelector('button');
      this.price = this.querySelector('.gg-mobile-purchase__price');
      this.media = window.matchMedia('(max-width: 749px)');
      this.primaryVisible = false;
      this.sync = this.sync.bind(this);
      this.moving = true;
      document.body.append(this);
      this.moving = false;
      this.visibility = new IntersectionObserver((entries) => {
        this.primaryVisible = entries.some((entry) => entry.isIntersecting);
        this.updateVisibility();
      }, { threshold: 0.1 });
      this.observer = new MutationObserver(this.sync);
      const main = document.querySelector('#MainContent');
      if (main) this.observer.observe(main, { childList: true, subtree: true, attributes: true, characterData: true, attributeFilter: ['disabled', 'aria-disabled', 'hidden', 'class'] });
      this.media.addEventListener('change', this.sync);
      this.button.addEventListener('click', () => {
        if (this.primary && !this.button.disabled) this.primary.click();
      });
      this.sync();
    }
    disconnectedCallback() {
      if (this.moving) return;
      this.visibility?.disconnect();
      this.observer?.disconnect();
      this.media?.removeEventListener('change', this.sync);
    }
    sync() {
      const primary = document.getElementById(this.dataset.submitId);
      if (primary !== this.primary) {
        this.visibility.disconnect();
        this.primary = primary;
        this.primaryVisible = false;
        if (primary) this.visibility.observe(primary);
      }
      if (!primary) {
        this.hidden = true;
        document.body.classList.remove('gg-has-mobile-purchase');
        return;
      }
      const label = primary.querySelector('span')?.textContent.trim() || primary.textContent.trim();
      if (this.button.textContent !== label) this.button.textContent = label;
      this.button.disabled = primary.disabled || primary.getAttribute('aria-disabled') === 'true';
      const info = primary.closest('product-info');
      const price = info?.querySelector('.product__info-container .price');
      const sale = price?.classList.contains('price--on-sale');
      const amount = price?.querySelector(sale ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
      const value = amount?.textContent.trim() || '';
      if (this.price.textContent !== value) this.price.textContent = value;
      const error = info?.querySelector('.product-form__error-message-wrapper:not([hidden])');
      if (error && error.textContent.trim() && error.textContent.trim() !== this.lastError) {
        this.lastError = error.textContent.trim();
        error.scrollIntoView({ block: 'center', behavior: 'auto' });
      }
      if (!error) this.lastError = '';
      this.updateVisibility();
    }
    updateVisibility() {
      this.hidden = !this.media.matches || !this.primary || this.primaryVisible;
      document.body.classList.toggle('gg-has-mobile-purchase', this.media.matches && !!this.primary);
    }
  });
}
